module.exports = __webpack_public_path__ + "static/media/tagsensor-id-location.4f33dfdf.jpg";